import {
  parseUnidadCaudal,
  parseUnidadPresion,
  type UnidadCaudal,
  type UnidadPresion,
} from '@/lib/checklists/units';

export interface ElementoInstrumentoGrupoPresion {
  nombre?: unknown;
  tipo?: unknown;
  tipo_equipo?: unknown;
  zona?: unknown;
  datos_tecnicos?: Record<string, any> | null;
}

export interface InstrumentosGrupoPresion {
  caudalimetro?: { unidad: UnidadCaudal; nombre?: string };
  manometro?: { unidad: UnidadPresion; nombre?: string };
}

const normalizar = (value: unknown): string =>
  (value ?? '')
    .toString()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();

const textoElemento = (el: ElementoInstrumentoGrupoPresion): string =>
  normalizar([el.tipo, el.tipo_equipo, el.nombre, el.zona].filter(Boolean).join(' '));

export const resolveInstrumentosGrupoPresion = (
  elementos: ElementoInstrumentoGrupoPresion[],
): InstrumentosGrupoPresion => {
  const instrumentos: InstrumentosGrupoPresion = {};
  let manometroLegacy: InstrumentosGrupoPresion['manometro'];

  for (const el of elementos) {
    const t = textoElemento(el);
    const dt = el.datos_tecnicos || {};

    if (!instrumentos.caudalimetro && t.includes('caudalimetro')) {
      instrumentos.caudalimetro = {
        unidad: parseUnidadCaudal(dt.rango_unidad),
        nombre: (el.nombre || 'Caudalímetro').toString(),
      };
    }

    const esManometro = t.includes('manometro');
    const esAspiracion = t.includes('aspiracion');
    const esImpulsion = esManometro && t.includes('impulsion') && !esAspiracion;
    const esLegacyImpulsion = esManometro && t.includes('presostato') && !esAspiracion;

    if (esImpulsion) {
      instrumentos.manometro = {
        unidad: parseUnidadPresion(dt.unidad_presion),
        nombre: (el.nombre || 'Manómetro de impulsión').toString(),
      };
      continue;
    }

    if (!manometroLegacy && esLegacyImpulsion) {
      manometroLegacy = {
        unidad: parseUnidadPresion(dt.unidad_presion),
        nombre: (el.nombre || 'Manómetro de impulsión').toString(),
      };
    }
  }

  if (!instrumentos.manometro && manometroLegacy) {
    instrumentos.manometro = manometroLegacy;
  }

  return instrumentos;
};